/* DNA Free Hat — auto-add the Thrift DNA Trucker Hat as a free gift when the
   cart holds any archive item (a product NOT in DNA Originals). Pairs with an
   automatic Buy-X-Get-Y discount that zeroes the hat's price. Hooks the theme's
   existing cart events (cart-drawer.liquid already refreshes/opens on add). */
(function () {
  var CFG = window.DNA_FREE_HAT || {};
  if (!CFG.enabled || !CFG.hatVariantId) return;

  var DNA = {};
  (CFG.dnaOriginalIds || []).forEach(function (id) { DNA[id] = true; });

  var GIFT_PROP = '_free_gift';
  var running = false, pending = false, timer = null;

  function isHat(i)     { return i.variant_id === CFG.hatVariantId; }
  function isGift(i)    { return isHat(i) && i.properties && i.properties[GIFT_PROP] === 'true'; }
  function isArchive(i) { return !isHat(i) && !DNA[i.product_id]; }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
  }
  function addHat() {
    var props = {}; props[GIFT_PROP] = 'true';
    return post('/cart/add.js', { items: [{ id: CFG.hatVariantId, quantity: 1, properties: props }] });
  }
  function changeLine(key, qty) { return post('/cart/change.js', { id: key, quantity: qty }); }

  function done() {
    running = false;
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    if (pending) { pending = false; schedule(); }
  }

  function reconcile() {
    if (running) { pending = true; return; }
    running = true;
    getCart().then(function (cart) {
      if (!cart) { running = false; return; }
      var items = cart.items || [], hatLine = null, giftLine = null, hasArchive = false;
      items.forEach(function (it) {
        if (isHat(it)) { hatLine = it; if (isGift(it)) giftLine = it; }
        if (isArchive(it)) hasArchive = true;
      });
      if (hasArchive && !hatLine && CFG.hatInStock) { addHat().then(done, done); return; }
      if (!hasArchive && giftLine)                  { changeLine(giftLine.key, 0).then(done, done); return; }
      if (hasArchive && giftLine && giftLine.quantity !== 1) { changeLine(giftLine.key, 1).then(done, done); return; }
      running = false;
      if (pending) { pending = false; schedule(); }
    }).catch(function () { running = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 200); }

  ['cart:updated', 'cart:build', 'ajaxProduct:added', 'cart:added', 'cart:change', 'cart:refresh']
    .forEach(function (ev) { document.addEventListener(ev, schedule); });

  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
})();
